export default __webpack_public_path__ + "static/media/aws-lambda.3c97ced5.svg";